import Axios from '@/axios'

// 查询设备：web:device:index
export const QueryTerminalIndex = data => {
  return Axios({
    url: '/device-manager/web-api/device/index',
    method: 'POST',
    type: 'json',
    data
  })
}

// 创建设备：web:device:create
export const TerminalCreate = data => {
  return Axios({
    url: `/device-manager/web-api/device/create`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 查询设备：web:device:update
export const TerminalUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/device/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除设备：web:device:delete
export const TerminalDelete = (id) => {
  return Axios({
    url: `/device-manager/web-api/device/delete/${id}`,
    method: 'POST',
    type: 'json',
  })
}

// 绑定设备：web:device:bind
export const BindTerminal = (data) => {
  return Axios({
    url: `/device-manager/web-api/device/bind`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 解绑设备：web:device:unbind
export const UnbindTerminal = (id) => {
  return Axios({
    url: `/device-manager/web-api/device/unbind/${id}`,
    method: 'POST',
    type: 'json',
  })
}

// 导入设备：web:device:batchCreate
export const TerminalImport = (data) => {
  return Axios({
    url: `/device-manager/web-api/device/batch_create`,
    method: 'POST',
    type: 'json',
    data
  })
}

